export const DEFAULT_LOGIN_REDIRECT_PATH = '/home';

export const getLoginRedirectTarget = (redirectPath: string) => {
  const searchParams = new URLSearchParams({
    redirect: redirectPath,
  });

  return `/login?${searchParams.toString()}`;
};

export const getLoginRedirectPath = (state: unknown, searchParams: URLSearchParams): string => {
  const stateRedirect =
    typeof state === 'object' &&
    state !== null &&
    'redirect' in state &&
    typeof state.redirect === 'string'
      ? state.redirect
      : null;

  return stateRedirect || searchParams.get('redirect') || DEFAULT_LOGIN_REDIRECT_PATH;
};

export const getPrefilledLoginEmail = (searchParams: URLSearchParams, redirectPath: string) => {
  const urlEmail = searchParams.get('email');
  const redirectEmail = new URL(redirectPath, 'https://app.mavue.io').searchParams.get('email');

  return urlEmail || redirectEmail || '';
};
